import React, { Fragment, useState } from 'react';
import './Workflow.scss'
import ClientInterviewTask from './tasks/ClientInterviewTask'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import Button from '../../../../components/library/buttons/Button';
import IdentityConfirmationTask from './tasks/IdentityConfirmationTask';
import AuthorizationTask from './tasks/AuthorizationTask';
import DocumentUploadTask from './tasks/DocumentUploadTask';
import ReviewReturnVirTask from './tasks/ReviewReturnVirTask';
import ClientCallPaymentVirTask from './tasks/ClientCallPaymentVirTask';
import ClientCallDocumentsVirTask from './tasks/ClientCallDocumentsVirTask';
import FileReturnVirTask from './tasks/FileReturnVirTask';
import SkeletonTask from '../../../../components/library/workflow-tasks/SkeletonTask';
import { WorkflowTasks } from '../../services/WorkflowTasks';
import ContentPlain from '../../../../components/layout/ContentPlain';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { TicketState } from '../../services/TicketState';
import CloseTicketModal from './CloseTicketModal';
import { TaskStatus } from '../../services/TaskStatus';
import ticketStateService from '../../services/ticketState/TicketStateService';
import virService from '../../services/vir/VirService';
import TicketActions from '../../../../store/ticketRedux';
import DateTime from '../../../../components/library/common/DateTime';
import { Permissions } from '../../../../app/services/Permissions';

const VIRWorkflow = () => {
    const [closeTicketDialogOpen, setCloseTicketDialogOpen] = useState(false);
    const [closeTicketError, setCloseTicketError] = useState(false);
    const [readyToFileComplete, setReadyToFileComplete] = useState(false);

    const ticket = useSelector(state => state.tickets.selectedTicket, shallowEqual)
    const ticketType = ticket ? ticket.ticketType.identifier.toUpperCase() : null;

    const canEditTicket = useSelector(state => (state.accountData.permissions || []).includes(Permissions.EDIT_TICKET))
    const closedDate = useSelector(state => {
        var t = state.tickets.selectedTicket;
        if (t) { 
            var currStatus = t.ticketState.identifier
            if (t.stateTransitions && t.stateTransitions.length > 0
                && t.stateTransitions[0].finalState.identifier === currStatus
                && t.stateTransitions[0].timestamp) {
                return t.stateTransitions[0].timestamp
            } else {
                return t.lastModified
            }
        }
        return null;        
    })

    const dispatch = useDispatch();

    const showCloseTicketDialog = () => {
        setCloseTicketError(false);
        setCloseTicketDialogOpen(true)
    }

    const handleCloseTicket = async (ticketStateIdentifier, reasonIdentifier) => {
        var revert = await virService.revertPermissionsForCancelledTicket(ticket.viewModelId, ticket.taxYear);
        
        if (revert) {
            var updatedTicket = await ticketStateService.updateTicketState(ticket, ticketStateIdentifier, reasonIdentifier);
            if (updatedTicket) { 
                dispatch(TicketActions.setSelectedTicket(updatedTicket));
                setCloseTicketDialogOpen(false)
            } else {
                setCloseTicketError(true);
                }
        } else {
            setCloseTicketError(true);
        }
    }

    const handleHideModal = () => {
        setCloseTicketDialogOpen(false);
        setCloseTicketError(false);
    }

    const handleReadyToFile = (readyToFileComplete) => {
        setReadyToFileComplete(readyToFileComplete)
    }

    return (
        <ContentPlain elementId='vir-workflow-tab'>
            <div className='columns level workflow'>
                <div className='column is-7 is-offset-1'>
                    <div>
                        <h3><HrbTranslate text='Tickets.Tasks.Tasks' /></h3>
                        <p className='p1'><HrbTranslate text='Tickets.Tasks.Description' /></p>
                    </div>
                </div>
                <div className='column is-3 is-right'>
                    <div className='cancel-btn-holder'>
                        {ticket && ticket.ticketState.identifier === TicketState.OPEN && canEditTicket &&
                            <Button
                                elementId='ticket-close-btn'
                                labelKey='Tickets.CloseTicket.CloseBtn'
                                buttonStyles='tertiary'
                                disabled={!ticket}
                                onClick={showCloseTicketDialog}
                            />
                        }
                    </div>
                </div>
                <div className='column is-1' />
            </div>
            {ticket && ticket.ticketState.identifier !== TicketState.OPEN && 
                <div className='columns level workflow'>
                    <div className='column is-10 is-offset-1'>
                        <div>
                        {ticket.ticketState.identifier === TicketState.CLOSED_COMPLETED_IN_OFFICE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.CompletedInOffice'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        {ticket.ticketState.identifier === TicketState.CLOSED_INCOMPLETE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.Incomplete'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        </div>
                    </div>
                </div>
            }
            {ticket &&
                <Fragment>
                    <ClientInterviewTask ticket={ticket} />
                    <IdentityConfirmationTask ticket={ticket} />
                    <AuthorizationTask ticket={ticket} />
                    <DocumentUploadTask ticket={ticket} />
                    <ReviewReturnVirTask ticket={ticket} readyToFile={readyToFileComplete} />
                    <ClientCallDocumentsVirTask ticket={ticket} readyToFile={readyToFileComplete} />
                    <ClientCallPaymentVirTask ticket={ticket} onReadyToFile={handleReadyToFile}/>
                    <FileReturnVirTask ticket={ticket} />
                </Fragment>
            }
            {!ticket &&
                <Fragment>
                    <SkeletonTask taskId={WorkflowTasks.INTERVIEW_COMPLETED} />
                    <SkeletonTask taskId={WorkflowTasks.CONFIRM_ID} />
                    <SkeletonTask taskId={WorkflowTasks.AUTHORIZE_CRA} />
                    <SkeletonTask taskId={WorkflowTasks.DOCS_UPLOADED} />
                    <SkeletonTask taskId={WorkflowTasks.RETURN_REVIEWED} />
                    <SkeletonTask taskId={WorkflowTasks.CLIENT_CALL_DOCUMENTS} />
                    <SkeletonTask taskId={WorkflowTasks.CLIENT_CALL_PAYMENT} />
                    <SkeletonTask taskId={WorkflowTasks.FILE_RETURN_VIR} />
                </Fragment>
            }
            <CloseTicketModal
                isOpen={closeTicketDialogOpen} status={closeTicketError ? TaskStatus.ERROR : TaskStatus.IN_PROGRESS} onCancel={handleHideModal}
                onCloseTicket={handleCloseTicket} updateFailed={closeTicketError} ticketType={ticketType}/>
        </ContentPlain>
    );
}

VIRWorkflow.whyDidYouRender = false;

export default VIRWorkflow